"use client";

import { useState } from "react";
import { Play } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
interface VideoItem {
  id: number;
  thumbnail: string;
  videoUrl: string;
  title: string;
}
const videos: VideoItem[] = [{
  id: 1,
  thumbnail: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1463994/img/combat_highlight_one.png",
  videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
  title: "Combat Highlight 1"
}, {
  id: 2,
  thumbnail: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1463994/img/training_session_footage.png",
  videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
  title: "Training Session"
}, {
  id: 3,
  thumbnail: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1463994/img/tournament_finals_clip.png",
  videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
  title: "Tournament Finals"
}, {
  id: 4,
  thumbnail: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1463994/img/technique_demonstration.png",
  videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
  title: "Technique Demo"
}, {
  id: 5,
  thumbnail: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1463994/img/sparring_match_recording.png",
  videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
  title: "Sparring Match"
}, {
  id: 6,
  thumbnail: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1463994/img/championship_moment.png",
  videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
  title: "Championship Moment"
}, {
  id: 7,
  thumbnail: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1463994/img/fighter_interview_clip.png",
  videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
  title: "Fighter Interview"
}, {
  id: 8,
  thumbnail: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1463994/img/behind_scenes_footage.png",
  videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
  title: "Behind the Scenes"
}];
export default function VideoGallery() {
  const [selectedVideo, setSelectedVideo] = useState<VideoItem | null>(null);
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return;
}